import { Button, Col, Form, Input, notification, Row, Select } from 'antd'
import { createRef, useEffect, useState } from 'react'
import contactService from 'src/services/contact.service'
import { RULE_FORM } from 'src/utils/formValidation'
import { ArrowRightOutlined, SafetyCertificateOutlined } from '@ant-design/icons'
import * as api from 'src/configs/API'
import request from 'src/utils/request';

import ReCAPTCHA from 'react-google-recaptcha'
import addressServices from 'src/services/address.service'
import { toLowerCaseNonAccentVietnamese } from 'src/utils/common'
const recaptchaRef = createRef()

const ContactFormModify = () => {
	const [loading, setLoading] = useState(false)
	const [isSubmit, setIsSubmit] = useState(false)
	const [form] = Form.useForm()
	const [isCanCreate, setIsCanCreate] = useState(false)
	const [address, setAddress] = useState("")
	const [token, setToken] = useState('')
	const [listProvince, setListProvince] = useState([])
	const [listWard, setListWard] = useState([])
	const [provinceId, setProvinceId] = useState(null)
	const [wardId, setWardId] = useState(null)

	const getProvincesByCountryID = () => {
		addressServices
			.queryCitiesByCountryID("VN")
			.then((response) => {
				setListProvince(response?.provinces)
			})
			.catch(console.log)
	}
	const getWardsByProvinceID = (provinceID) => {
		addressServices
			.queryWards(provinceID + provinceID)
			.then((response) => {
				setListWard(response?.wards)
			})

			.catch(console.log)
	}
	useEffect(() => {
		getProvincesByCountryID();
	}, [])

	const handleSubmit = async (values) => {
		if (!token || token === '') {
			notification.error({
				message: 'Vui lòng xác thực ReCAPTCHA!',
			})
			return;
		}
		if (!provinceId) {
			notification.error({
				message: 'Vui lòng chọn tỉnh thành',
			})
		}
		if (!wardId) {
			notification.error({
				message: 'Vui lòng chọn phường xã',
			})
		}
		setLoading(true)
		try {

			values.buttonId = 'news_contact';
			values.formId = 'news_contact_form';
			values.provinceId = provinceId;
			values.wardId = wardId;
			const response = contactService.insertContactPushtoCRMLead(values, { 'TokenRecaptcha': token })
			if (!response.isError) {
				notification.success({
					message: 'Cảm ơn bạn đã liên hệ!',
					description: 'Chúng tôi sẽ phản hồi sớm nhất có thể',
				})
				setIsSubmit(true)
				form.resetFields()
			}
		} catch (error) {
			console.log(error)
		}
		setLoading(false)
	}
	return (
		<div className="contact__form contact__form__modify">
			{isSubmit && (
				<div >
					<img src="/images/contactform_img.png" alt="Liên hệ thành công" style={{ width: 300, display: 'block', margin: '0 auto' }} />
					<h1 style={{ textAlign: 'center', fontSize: 40, fontWeight: 'bold', lineHeight: "48px" }}>Cảm ơn bạn đã tin tưởng và liên hệ với 247Express!</h1>
					<p style={{ color: '#5E6278', textAlign: 'center' }}>
						Thông tin của bạn đã được chuyển đến bộ phận tiếp nhận. Đội ngũ của chúng tôi sẽ liên hệ để tư vấn giải pháp phù hợp nhất theo nhu cầu vận chuyển của bạn trong vòng 4 giờ làm việc (trừ chủ nhật & ngày lễ).
					</p>
				</div>
			)}
			{/* <h1 className="text-center">{isSubmit ? 'Cảm ơn quý khách!' : 'Liên hệ'}</h1> */}
			{/* <div className="text-center">
				<img
					src={isSubmit ? '/images/thanks-noti.png' : '/images/contactform_img.png'}
					alt="Liên hệ"
				/>
			</div> */}
			{/* {isSubmit ? (
				<p className="text-center text-contact">
					<h4 style={{ fontWeight: 600 }}>Hệ thống đã ghi nhận thông tin thành công!</h4>
					Nhân viên <span className="text-center text-red">247Express</span> sẽ liên hệ đến bạn
					trong thời gian sớm nhất
				</p>
			) : (
				<p className="text-center text-contact">
					Vui lòng để lại thông tin để nhân viên{' '}
					<span className="text-center text-red">247Express</span> có thể liên hệ tới bạn sớm nhất
				</p>
			)} */}
			{!isSubmit && (
				<Form form={form} name="home-contact-form" layout="vertical" onFinish={handleSubmit}>
					<Row gutter={24} wrap>
						<Col span={24}>
							<span style={{ fontSize: 16, fontWeight: 600, color: "#CC0000" }}><img src='/images/contact-form/hands.png' style={{ width: 21 }}></img> Đăng ký tư vấn - điền ngay!</span>
						</Col>
						<Col span={24}>
							<Row gutter={12}>
								<Col xl={24} lg={24} md={24} sm={24} xs={24}>
									<Form.Item
										rules={[
											{ required: true, message: 'Vui lòng nhập tên' },
											{ whitespace: true, message: 'Vui lòng nhập tên' },
											{ max: 200, message: 'Vui lòng nhập tối đa 200 ký tự' },
										]}
										style={{ marginTop: 12 }}
										name="name"
									>
										{/* <Input placeholder="Họ và Tên" /> */}
										<div className="ph-wrap">
											<Input
												size='small'
												placeholder=" "
												prefix={<img src="/images/contact-form/userprefix.png" style={{ width: 21, height: 21 }} />}
												className="ph-input"
											/>

											<span className="ph-fake">
												Họ và tên người liên hệ<span className="req">*</span>
											</span>
										</div>
									</Form.Item>
								</Col>
								<Col xl={24} lg={24} md={24} sm={24} xs={24}>
									<Form.Item rules={RULE_FORM.PHONE_NUMBER} style={{ marginTop: 12 }} name="phone">
										{/* <Input placeholder="Số điện thoại" /> */}
										<div className="ph-wrap">
											<Input
												size='small'
												placeholder=" "
												prefix={<img src="/images/contact-form/phoneprefix.png" style={{ width: 21, height: 21 }} />}
												className="ph-input"
											/>

											<span className="ph-fake">
												Số điện thoại <span className="req">*</span>
											</span>
										</div>
										{/* <Input
													className="placeholder-black"
													prefix={
														<img
															src="/images/contact-form/phoneprefix.png"
															style={{ width: 21 }}
														></img>
													}
													placeholder="Số điện thoại *"
												/> */}
									</Form.Item>
								</Col>
							</Row>
						</Col>
						<Col span={24}>
							<Form.Item
								rules={[{ type: 'email', message: 'Email không đúng định dạng!' }]}
								style={{ marginTop: 12 }}
								name="email"
							>
								{/* <Input placeholder="Email" /> */}
								<div className="ph-wrap">
									<Input
										size='small'
										placeholder=" "
										prefix={<img src="/images/contact-form/mailprefix.png" style={{ width: 21, height: 21 }} />}
										className="ph-input"
									/>

									<span className="ph-fake">
										Email
									</span>
								</div>
							</Form.Item>
						</Col>

						<Col span={24}>

							<Form.Item
								rules={[{ required: true, message: 'Vui lòng chọn tỉnh thành' }]}
								style={{ marginTop: 12 }}
								name="province"
							>
								<div className={`fp-wrap ${provinceId ? "fp-has-value" : ""}`}>
									<div className="fp-select-inner">
										<img
											src="/images/contact-form/teleprefix.png"
											alt=""
											className="fp-prefix-icon"
											style={{ width: 21, height: 21, marginLeft: 18 }}
										/>
										<Select
											showSearch
											placeholder=""
											optionFilterProp="children"
											filterOption={(input, option) =>
												toLowerCaseNonAccentVietnamese(option.children.toLowerCase()).includes(
													toLowerCaseNonAccentVietnamese(input.toLowerCase())
												)
											}
											onChange={(value) => {
												form.setFieldValue('ward', null);
												setProvinceId(value);
												form.setFieldsValue({
													province: value
												});
												getWardsByProvinceID(value);
											}}
										>
											{listProvince?.map((item) => (
												<Select.Option key={item.provinceID} value={item.provinceID}>
													{item.provinceName}
												</Select.Option>
											))}
										</Select>
									</div>
									<span className="fp-placeholder" style={{ marginLeft: 28 }}>
										Tỉnh/Thành Phố <span className="fp-star">*</span>
									</span>
								</div>

							</Form.Item>

						</Col>
						<Col span={24}>
							<Form.Item
								rules={[
									{ required: true, message: 'Vui lòng chọn phường xã' },
								]}
								style={{ marginTop: 12 }}
								name="ward"
							>
								<div className={`fp-wrap ${wardId ? "fp-has-value" : ""}`}>
									<div className="fp-select-inner">
										<img
											src="/images/contact-form/teleprefix.png"
											alt=""
											className="fp-prefix-icon"
											style={{ width: 21, height: 21, marginLeft: 18 }}
										/>
										<Select
											showSearch
											optionFilterProp="children"
											filterOption={(input, option) =>
												toLowerCaseNonAccentVietnamese(option.children.toLowerCase()).indexOf(
													toLowerCaseNonAccentVietnamese(input.toLowerCase())
												) >= 0
											}
											onChange={e => {
												setWardId(e);

												form.setFieldsValue({
													ward: e
												})
											}}
										>
											{listWard?.map((item) => (
												<Select.Option value={item?.wardID} key={item?.wardID}>
													{item?.wardName}
												</Select.Option>
											))}
										</Select>
									</div>
									<span className="fp-placeholder" style={{ marginLeft: 28 }}>
										Phường/xã <span className="fp-star">*</span>
									</span>
								</div>

							</Form.Item>
						</Col>
						{/* <Col span={24}>
							<Form.Item
								rules={[
									{ min: 10, message: 'Địa chỉ phải lớn hơn 10 ký tự!' },
									{ required: true, message: 'Vui lòng nhập địa chỉ' },
									{ max: 500, message: 'Vui lòng nhập tối đa 500 ký tự' },
								]}
								style={{ marginTop: 12 }}
								name="content"
							>
								<div className="ph-wrap">
									<Input
										size='small'
										placeholder=" "
										prefix={<img src="/images/contact-form/teleprefix.png" style={{ width: 21, height: 21 }} />}
										className="ph-input"
										onChange={(e) => {
											setAddress(e.target.value);
										}}
									/>

									<span className="ph-fake">
										Địa chỉ công ty chi tiết <span className="req">*</span>
									</span>
								</div>
							</Form.Item>
						</Col> */}
						<Col span={24}>
							<Form.Item
								name="Captcha"
								style={{
									marginTop: 18,
								}}
							>
								<ReCAPTCHA
									sitekey={api.SITE_KEY}
									onChange={(token) =>{setToken(token)
									}}
									onExpired={(token) => setToken('')}
									ref={recaptchaRef}
									hl={'vi'}
								/>
							</Form.Item>
						</Col>
						<Col span={24}>

							<p style={{ fontSize: 13, margin: "20px 0px" }}>
								<SafetyCertificateOutlined />
								&nbsp; Bằng việc gửi thông tin, bạn đồng ý với
								<a href="https://247express.vn/chinh-sach-bao-mat"> chính sách bảo mật </a>của chúng tôi.{' '}
							</p>
						</Col>
						<Col span={24}>
							<div className="send-btn__wrapper">
								{/* <Button className="btn-cancel" onClick={() => form.resetFields()}>
									Huỷ
								</Button> */}
								{/* <Button loading={loading} htmlType="submit" type="primary">
									Xác nhận
								</Button> */}
								<Button
									style={{ width: '100%', height: 44, fontSize: 16, lineHeight: '24px' }}
									type="primary"
									htmlType="submit"
								>
									Nhận Tư Vấn Ngay <ArrowRightOutlined />
								</Button>
							</div>
						</Col>
						<Col span={24} style={{ textAlign: 'center', marginTop: 12 }}>
							<i>Bạn không phải là Khách hàng Doanh nghiệp? Tìm hiểu thêm <a href='https://247express.vn/tin-tuc/tin-tuc-va-su-kien/huong-dan-gui-hang-danh-cho-khach-hang-le/759?utm_source=LDPd'>tại đây</a>.</i>
						</Col>
					</Row>
					<Row gutter={[16, 12]} justify="space-between" style={{ marginTop: 24, alignItems: 'stretch' }}>
						{/* <Col xs={0} md={6}>
							<img src="/images/contactform_img.png" alt="Liên hệ" style={{ maxWidth: '100%', height: 'auto' }} />
						</Col> */}

						<Col xs={8} md={8} style={{ display: 'flex' }}>
							<div className="featureItem">
								<img style={{ width: 42, height: 42 }} src="/images/contact-form/star.png" alt="20k+" />
								<span>20.000+ khách hàng<br />doanh nghiệp</span>
							</div>
						</Col>

						<Col xs={8} md={8} style={{ display: 'flex' }}>
							<div className="featureItem">
								<img style={{ width: 48, height: 42 }} src="/images/contact-form/delivery-done.png" alt="Giao nhanh" />
								<span>Giao nhanh<br />toàn quốc</span>
							</div>
						</Col>

						<Col xs={8} md={8} style={{ display: 'flex' }}>
							<div className="featureItem">
								<img style={{ width: 48, height: 42 }} src="/images/contact-form/box.png" alt="Quản lý đơn" />
								<span>Quản lý đơn hàng<br />thông minh</span>
							</div>
						</Col>
					</Row>

				</Form>
			)}
			{/* <style jsx>{`
        .featureItem {
          display: flex;
          flex-direction: column;
          align-items: center;     
          justify-content: center; 
          gap: 8px;
          text-align: center;
          padding: 12px;
          width: 100%;
          height: 100%;            
        }
      `}</style> */}
		</div>
	)
}

export default ContactFormModify
